import {useCAPIQuery} from '@github-ui/copilot-shared-ui/capi/use-capi-query'
import {fetchTaskHistory} from '../utils/fetch-task-history'
import {useTaskHistoryRequired} from '../contexts/new-task-context'

export type TaskAhpHistory = Awaited<ReturnType<typeof fetchTaskHistory>>

export function taskAhpHistoryQueryKey(taskId: string | undefined, apiURL?: string) {
  return ['task-ahp-history', taskId, apiURL] as const
}

interface UseTaskAhpHistoryOptions {
  refetchOnMount?: boolean | 'always'
}

export function useTaskAhpHistory(
  taskId: string | undefined,
  apiURL?: string,
  enabled = true,
  {refetchOnMount = 'always'}: UseTaskAhpHistoryOptions = {},
) {
  const historyRequired = useTaskHistoryRequired(taskId)
  return useCAPIQuery({
    queryKey: taskAhpHistoryQueryKey(taskId, apiURL),
    queryFn: ({signal}) => {
      if (!taskId) throw new Error('No task ID provided for saved history.')
      return fetchTaskHistory(taskId, {copilotApiUrl: apiURL, signal})
    },
    enabled: enabled && !!taskId && historyRequired,
    staleTime: 0,
    retry: false,
    refetchOnMount,
    refetchOnWindowFocus: false,
    refetchOnReconnect: false,
  })
}
